import React from 'react';
import { Link } from 'react-router-dom';
import { dhfApi } from '../../utils/dhfApi';

/**
 * Shared bits of the Document Branches screens (2026-10-27, design/DESIGN_DOC_VARIANTS.md,
 * mockup https://claude.ai/artifact/UnNKTcPo9nHVGbp4SNUuh9). Classes are `dhfv-` (Note #15).
 */

/** The Document | Branches tabs under a DHF document's bar (mockup screen 1). */
export function DocTabs({ setupId, docId, active, count }) {
  return (
    <nav className="dhfv-doctabs" aria-label="Document views">
      <Link to={`/dhf/${setupId}/doc/${docId}`} className={`dhfv-doctab${active === 'doc' ? ' dhfv-doctab--on' : ''}`}
            aria-current={active === 'doc' ? 'page' : undefined}>Document</Link>
      <Link to={`/dhf/${setupId}/doc/${docId}/variants`}
            className={`dhfv-doctab${active === 'variants' ? ' dhfv-doctab--on' : ''}`}
            aria-current={active === 'variants' ? 'page' : undefined}>
        Branches{count != null ? ` · ${count}` : ''}
      </Link>
    </nav>
  );
}

/** Word diff segments [{op: eq|ins|del, text}] drawn inline. */
export function Diff({ segs }) {
  if (!segs || !segs.length) return null;
  return (
    <>
      {segs.map((s, i) => (
        s.op === 'eq' ? <span key={i}>{s.text}</span>
          : <span key={i} className={s.op === 'ins' ? 'dhfv-ins' : 'dhfv-del'}>{s.text}</span>
      ))}
    </>
  );
}

export function hasChange(segs) {
  return (segs || []).some((s) => s.op !== 'eq');
}

export const REASONS = ['Regulation', 'Product model', 'Customer', 'Language', 'Market'];

export function ReasonChip({ reason }) {
  if (!reason) return null;
  const tone = reason === 'Regulation' ? 'blue' : reason === 'Product model' ? 'purple' : 'grey';
  return <span className={`dhfv-reason dhfv-reason--${tone}`}>{reason}</span>;
}

/** Fetch the branch as Word / PDF and save it (a file is fetched, never linked — Note #85). */
export async function downloadVariant(setupId, vid, format) {
  const { blob, name } = await dhfApi.exportVariant(setupId, vid, format);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
